import { getCsrfToken } from '@betterment/js-runtime';
import { Controller } from '@hotwired/stimulus';

import { locationReplace } from '../../Shared/path-helpers';

export default class extends Controller {
  declare handoffPathValue: string;

  declare successPathValue: string;

  static values = { handoffPath: String, successPath: String };

  async connect() {
    await this.processHandoff();
  }

  async processHandoff() {
    const handoffToken = window.location.hash.slice(1);

    const response = await fetch(this.handoffPathValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCsrfToken() ?? '',
      },
      body: JSON.stringify({
        mobile_webview_handoff_token: handoffToken,
      }),
    });

    if (response.ok) {
      locationReplace(this.successPathValue);
    } else {
      throw new Error(`Handoff failed with status: ${response.status}`);
    }
  }
}
